import React from 'react';
import { scrollToBlogElement } from '../../../utils/getHeadings';

const TableOfContents = ({ content }: { content: any }) => {
  const [openToc, setOpenToc] = React.useState(false);

  return (
    <div className="flex mx-auto w-full items-center justify-center">
      <div
        className={`p-4 2xl:px-12 w-full lg:mx-[6%] py-3 ${
          openToc ? 'h-[400px] sm:h-fit' : 'auto'
        } ${
          openToc ? 'overflow-y-auto' : 'none'
        } bg-[#E6F2FB] rounded-[6px] flex-col gap-2 my-4`}
      >
        <div className="flex justify-between items-center">
          <p className="text-[#222] text-base sm:text-lg xl:text-xl font-semibold 2xl:my-4 my-2">
            Table of Contents
          </p>

          <button
            className="text-[13px] sm:text-sm text-[#0881D8] border-[0.5px] bg-[#0881d8] bg-opacity-5 border-[#0881D8] w-[50px] h-[25px] sm:w-[70px] sm:h-[28px] rounded-[4px]"
            onClick={() => setOpenToc(!openToc)}
          >
            {openToc ? 'Hide' : 'Show'}
          </button>
        </div>
        {openToc && (
          <div className="flex flex-col sm:gap-2 pt-2">
            {content?.headings?.map((item: any, index: number) => (
              <div key={item.id} className={`pl-${item.level === 3 ? 4 : 2}`}>
                <span className="text-sm sm:text-base font-normal pr-2 text-[#0881d8]">
                  {index + 1}.
                </span>
                <span
                  onClick={() => scrollToBlogElement(item.id)}
                  className="cursor-pointer text-[#0881d8] text-start font-normal text-sm sm:text-base hover:underline ml-1"
                >
                  {item.text.replace(/&nbsp;$/, '')}
                </span>
                {item?.subheadings?.length > 0 && (
                  <div className="pl-4 gap-2 flex flex-col py-2">
                    {item?.subheadings?.map(
                      (subitem: any, subindex: number) => (
                        <div key={subitem.id} className="pl-2">
                          <span className="text-[13px] sm:text-sm xl:text-[15px] font-medium text-[#0881d8] pr-2">
                            {`${index + 1}.${subindex + 1}`}
                          </span>
                          <span
                            onClick={() => scrollToBlogElement(subitem.id)}
                            className="cursor-pointer text-[#0881d8] text-start text-[13px] sm:text-sm xl:text-[15px] font-normal hover:underline ml-1"
                          >
                            {subitem.text.replace(/&nbsp;$/, '')}
                          </span>
                        </div>
                      )
                    )}
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default TableOfContents;
